const frontendURL = '/cat/local_user/';
const backendURL = '/api/references/local_user/';
// const backendURL = '/api/auth/user/';
const name = 'Користувачі';

const instance = {
  frontendURL,
  backendURL,
  name,
};
export default instance;
